import React from "react";
import AppBar from "@mui/material/AppBar";

import GlossaryContent from "shared/modals/GlossaryContent";
import PrivacyContent from "shared/modals/PrivacyContent";
import TermsContent from "shared/modals/TermsContent";

import Modal from "shared/modals/Modal";

const Footer = () => {
  return (
    <AppBar
      id="footer"
      component="footer"
      color="inherit"
      elevation={0}
      sx={{
        top: "auto",
        bottom: 0,
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        whiteSpace: "nowrap",
        fontSize: 12,
        borderTop: "1px solid #f9f9f9",
        "& a": {
          color: "text.gray",
        },
        "& a:hover, &a:focus": {
          color: "secondary.main",
        },
        "& > nav": {
          textAlign: "center",
          "& > span": {
            color: "text.gray",
            padding: 1,
          },
        },
      }}
    >
      <nav>
        <span>
          <Modal i18nKey="modals.glossary">
            <GlossaryContent i18nKey="modals.glossary.terms" />
          </Modal>
        </span>
        <span>|</span>
        <span>
          <Modal i18nKey="modals.privacy">
            <PrivacyContent />
          </Modal>
        </span>
        <span>|</span>
        <span>
          <Modal i18nKey="modals.terms">
            <TermsContent />
          </Modal>
        </span>
        <span>|</span>
        <span>
          <a href="mailto:analytics@icer.org">Contact us</a>
        </span>
        <span>|</span>
        <span>© ICER, {new Date().getFullYear()}</span>
      </nav>
    </AppBar>
  );
};

export default Footer;
